"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import './tab.css';
const TabItemPropTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired, //
    content: PropTypes.node.isRequired,
};
// type TabItemType = InferProps<typeof TabItemPropTypes>;
/**
 * Tab — simple tabbed UI: clickable headers with content panes.
 *
 * @param {arrayOf} [props.tabs] - Array of tab items: { id, label, content }.
 * @param {oneOf} [props.orientation] - Tab orientation: 'top' | 'bottom' | 'left' | 'right'.
 * @param {string} [props.defaultActiveTab] - Id of the tab that should be active initially.
 * @param {function} [props.onTabChange] - Callback invoked when the active tab changes (tabId).
 */
Tab.propTypes = {
    /** Array of tabs to render, each should include id, label, and content. */
    tabs: PropTypes.arrayOf(PropTypes.shape(TabItemPropTypes).isRequired).isRequired,
    /** Layout orientation for the tab headers. */
    orientation: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    /** Optional default active tab id. */
    defaultActiveTab: PropTypes.string,
    /** Optional change handler called with the new tab id. */
    onTabChange: PropTypes.func,
};
export function Tab({ tabs, orientation = 'top', defaultActiveTab, onTabChange }) {
    const [activeTab, setActiveTab] = useState(defaultActiveTab || tabs[0]?.id || '');
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        onTabChange?.(tabId);
    };
    const activeContent = tabs.find(tab => tab.id === activeTab)?.content;
    const tabClass = `tab-container tab-${orientation}`;
    return (_jsxs("div", { className: tabClass, children: [_jsx("div", { className: "tab-headers", children: tabs.map(tab => (_jsx("button", { className: `tab-header ${activeTab === tab.id ? 'active' : ''}`, onClick: () => handleTabClick(tab.id), children: tab.label }, tab.id))) }), _jsx("div", { className: "tab-content", children: activeContent })] }));
}
